export var keyDownAction = function (f) { return function (e) {
    if (e.key === 'Enter' || e.key === ' ')
        f(e);
}; };
//# sourceMappingURL=keyDownAction.js.map